import { Component, AfterViewInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MaterialModule } from '../shared/material/material.module';
import { CommonModule } from '@angular/common';
import { ContainerComponent } from '../shared/container/container.component';

@Component({
  selector: 'app-my-account',
  standalone: true,
  imports: [CommonModule, RouterOutlet, MaterialModule, ContainerComponent],
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements AfterViewInit {
  router: Router = inject(Router);
  isLoading = true;

  ngAfterViewInit(): void {
    setTimeout(() => (this.isLoading = false), 300);
  }
}
